<template>
  <div class="wrapper">
    <div class="animated fadeIn">

      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-danger fade show" role="alert" v-show="errors.any()">
            Missing required fields
          </div>

          <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="created">
            Application created!
          </div>

          <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="updated">
            Application updated!
          </div>
          <div class="alert alert-danger fade show" role="alert" v-if="destroyed">
            Application deleted! Return to <router-link :to="{ name: 'Apps'}" class="alert-link">Apps</router-link>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <strong>Application</strong>
            </div>
            <div class="card-block">

              <div class="form-group" :class="{'has-danger': errors.has('name')}">
                <label for="name"><b>Name</b></label>
                <input type="text" class="form-control" id="name" v-model="app.name" name="name" v-validate="'required'">
              </div>

              <div class="form-group" :class="{'has-danger': errors.has('uid')}">
                <label for="uid"><b>UID</b></label>
                <input type="text" class="form-control" id="uid" v-model="app.uid" name="uid" v-validate="'required'">
              </div>

              <div class="form-group">
                <label for="name">Version</label>
                <input type="text" class="form-control" id="version" v-model="app.version">
              </div>

              <div class="form-group" :class="{'has-danger': errors.has('platform')}">
                <label for="platform"><b>Platform</b></label>
                <select class="form-control" id="platform" v-model="app.platform" name="platform" v-validate="'required'">
                  <option value="android">Android</option>
                  <option value="ios">iOS</option>
                </select>
              </div>

            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <strong>Company</strong>
            </div>
            <div class="card-block">

              <div class="form-group">
                <label for="company_name">Name</label>
                <input type="text" class="form-control" id="company_name" v-model="app.company_name">
              </div>

              <div class="form-group">
                <label for="full_company_name">Full Name</label>
                <input type="text" class="form-control" id="full_company_name" v-model="app.full_company_name">
              </div>

              <div class="form-group">
                <label for="copyright_date">Copyright Date</label>
                <input type="text" class="form-control" id="copyright_date" v-model="app.copyright_date">
              </div>

              <div class="form-group">
                <label for="company_address">Address</label>
                <input type="text" class="form-control" id="company_address" v-model="app.company_address">
              </div>
            </div>
          </div>
        </div>

      </div><!--/.row-->

      <div class="row">

        <!-- Webservices -->
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <strong>Webservices</strong>
            </div>
            <div class="card-block">

              <div class="form-group" :class="{'has-danger': errors.has('branding')}">
                <label for="branding"><b>Branding</b></label>
                <input type="text" class="form-control" id="branding" v-model="app.branding" name="branding" v-validate="'required'">
                <small class="form-text text-muted">Required for branded legal documents</small>
              </div>

              <div class="form-group" :class="{'has-danger': errors.has('cdn')}">
                <label for="cdn"><b>CDN</b></label>
                <input type="text" class="form-control" id="cdn" v-model="app.cdn" name="cdn" v-validate="'required|url'">
                <small class="form-text text-muted">CDN base URL for serving files and assets</small>
              </div>

              <div class="form-group">
                <label for="domain">Domain</label>
                <input type="text" class="form-control" id="domain" v-model="app.domain">
                <small class="form-text text-muted">Domain for web pages</small>
              </div>

              <div class="form-group" :class="{'has-warning': errors.has('email')}">
                <label for="email">Email</label>
                <input type="text" class="form-control" id="email" v-model="app.email" name="email" v-validate="'email'">
                <small class="form-text text-muted">Email from where the mails are sent</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Google API -->
        <div class="col-sm-3">
          <div class="card">
            <div class="card-header">
              <strong>Google API</strong>
            </div>
            <div class="card-block">

              <div class="form-group">
                <label for="gplay_key">Google Play Key</label>
                <input type="text" class="form-control" id="gplay_key" v-model="app.gplay_key">
              </div>

              <div class="form-group">
                <label for="google_api_token">API Token</label>
                <input type="text" class="form-control" id="google_api_token" v-model="app.google_api_token">
              </div>

              <div class="form-group">
                <label for="google_api_secret">API Secret</label>
                <input type="text" class="form-control" id="google_api_secret" v-model="app.google_api_secret">
              </div>

              <div class="form-group">
                <label for="google_api_refresh_token">Refresh Token</label>
                <input type="text" class="form-control" id="google_api_refresh_token" v-model="app.google_api_refresh_token">
              </div>
            </div>
          </div>
        </div>

        <!-- Batch -->
        <div class="col-sm-3">
          <div class="card">
            <div class="card-header">
              <strong>Batch API</strong>
            </div>
            <div class="card-block">

              <div class="form-group">
                <label for="batch_dev_key">Dev Key</label>
                <input type="text" class="form-control" id="batch_dev_key" v-model="app.batch_dev_key">
                <small class="form-text text-muted">App API Key for testing</small>
              </div>

              <div class="form-group">
                <label for="batch_live_api_key">Live API Key</label>
                <input type="text" class="form-control" id="batch_live_api_key" v-model="app.batch_live_api_key">
                <small class="form-text text-muted">App API Key for production</small>
              </div>

              <div class="form-group">
                <label for="batch_rest_key">REST Key</label>
                <input type="text" class="form-control" id="batch_rest_key" v-model="app.batch_rest_key">
                <small class="form-text text-muted">Company REST Key</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!destroyed">
        <div class="col-sm-12 pull-right">
          <div class="form-group">
            <button type="button" class="btn btn-primary" @click="openSaveModal"><i class="fa fa-save"></i> Save</button>
            <button type="button" class="btn btn-danger" @click="openDestroyModal" v-if="!isNew"><i class="fa fa-trash"></i> Destroy</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import apps from 'services/apps'
import {EventBus} from 'services/eventBus'

export default {
  name: 'app',
  data () {
    return {
      app: {},
      destroyed: false,
      updated: false,
      created: false,
      isNew: false
    }
  },
  created () {
    if (this.$route.params.id === 'new') {
      this.isNew = true
    } else {
      apps.get(this, this.$route.params.id)
    }
  },
  methods: {
    openSaveModal () {
      EventBus.$emit('save-modal', {
        name: this.app.name,
        confirm: this.saveApp
      })
    },
    openDestroyModal () {
      EventBus.$emit('destroy-modal', {
        name: this.app.name,
        confirm: this.destroyApp
      })
    },
    destroyApp () {
      apps.destroy(this, this.app.id)
      window.scrollTo(0, 0)
    },
    saveApp () {
      this.$validator.validateAll()
      if (this.errors.any()) {
        console.log(this.errors)
        this.saveModal = false
        window.scrollTo(0, 0)
        return
      }

      if (this.isNew) {
        apps.create(this, this.app)
      } else {
        apps.update(this, this.app.id, this.app)
      }

      window.scrollTo(0, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apps/App.vue